import React, { useContext } from 'react';
import styled from 'styled-components';

import { TeamBasicDTO } from '@bb/domain/dist/types';

import {
  AuthContext,
  ContactDrawerContext,
  ContactDrawerMode,
  ContactDrawerType,
} from 'contexts';
import { Avatar, Text } from 'components';

type TeamSectionProps = {
  teamUsers: TeamBasicDTO;
};

const TeamSection: React.FC<TeamSectionProps> = ({ teamUsers }) => {
  const { auth } = useContext(AuthContext);
  const { openContactDrawer } = useContext(ContactDrawerContext);

  return (
    <TeamSectionContainer>
      {teamUsers
        .filter(user => user.id !== auth.id)
        .map(user => (
          <TeamAgentContainer data-cy={`team-agent-${user.id}`} key={user.id}>
            <AvatarContainer
              onClick={() =>
                openContactDrawer(
                  ContactDrawerMode.Profile,
                  ContactDrawerType.User,
                  user.id,
                )
              }
              data-cy="team-agent-view-details"
            >
              <Avatar user={user} />
            </AvatarContainer>
            <NameContainer
              onClick={() =>
                openContactDrawer(
                  ContactDrawerMode.Profile,
                  ContactDrawerType.User,
                  user.id,
                )
              }
            >
              <NameText data-cy="team-agent-name" textAlign="center" ellipsis>
                {user.firstName}
              </NameText>
            </NameContainer>
          </TeamAgentContainer>
        ))}
    </TeamSectionContainer>
  );
};

export default TeamSection;

const TeamSectionContainer = styled.div`
  display: flex;
  flex-wrap: wrap;

  padding: 12px;
`;

const TeamAgentContainer = styled.div`
  display: flex;
  flex-flow: column;

  padding: 4px 0;
  width: 25%;
  overflow: hidden;
`;

const AvatarContainer = styled.div`
  display: flex;
  justify-content: center;
  width: fit-content;
  margin: 0 auto;
  border-radius: 50%;
  cursor: pointer;
`;

const NameContainer = styled.div`
  width: 60px;
  margin: 0 auto;
  cursor: pointer;
`;

const NameText = styled(Text)`
  margin-top: 4px;
  font-size: 12px;
`;
